import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import type React from 'react';
import { NAVY, RADIUS_ITEM } from 'styles/tokens';

import type { ActiveFilter } from './types';

interface ActiveFilterChipsProps {
  activeFilters: ActiveFilter[];
  onRemove: (key: string) => void;
  onClearAll: () => void;
}

const ActiveFilterChips: React.FC<ActiveFilterChipsProps> = ({ activeFilters, onRemove, onClearAll }) => {
  const hasChips = activeFilters.length > 0;

  return (
    <Box
      sx={{
        display: { xs: 'none', md: 'flex' },
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 0.75,
        borderTop: hasChips ? `1px solid ${NAVY}08` : 'none',
        px: 2.5,
        pt: 0.75,
        pb: 1.25,
        minHeight: 40,
        boxSizing: 'border-box',
      }}
    >
      {hasChips &&
        activeFilters.map((filter) => (
          <Chip
            key={filter.key}
            label={
              <>
                <span style={{ color: `${NAVY}80` }}>{filter.label}:</span> {filter.displayValue}
              </>
            }
            onDelete={() => onRemove(filter.key)}
            deleteIcon={<CloseIcon sx={{ fontSize: '0.75rem !important' }} />}
            size="small"
            sx={{
              fontFamily: 'Jost, sans-serif',
              fontWeight: 500,
              fontSize: '0.75rem',
              color: NAVY,
              backgroundColor: `${NAVY}0A`,
              borderRadius: RADIUS_ITEM,
              '& .MuiChip-deleteIcon': {
                color: `${NAVY}80`,
                '&:hover': { color: NAVY },
              },
            }}
          />
        ))}

      {hasChips && (
        <Button
          onClick={onClearAll}
          size="small"
          sx={{
            textTransform: 'none',
            fontFamily: 'Jost, sans-serif',
            fontWeight: 500,
            fontSize: '0.75rem',
            color: `${NAVY}99`,
            minWidth: 'auto',
            px: 1,
            '&:hover': {
              backgroundColor: `${NAVY}08`,
              color: NAVY,
            },
          }}
        >
          Limpiar todo
        </Button>
      )}
    </Box>
  );
};

export default ActiveFilterChips;
